import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { DateTimeInput, Input, Static } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const min0 = validators.minValue(0);

const MarkAsCancelledForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues,  paymentMethod, showWarning, t }) => {
	const warningMessage = t(`PaymentMethod_${paymentMethod}_CancelRecurringWarning`);
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{showWarning && warningMessage && <Alert bsStyle='warning'><div dangerouslySetInnerHTML={{ __html: warningMessage }} /></Alert>}
			<Field name='cancellationDate' component={DateTimeInput} showTime={false} step={1} disabled={isReadonly} horizontal required label={t('PaymentHistory_CancellationDate')} validate={[validators.required]} />
			<Field name='outstandingTotal' component={Static} formatType='double' horizontal label={t('PaymentHistory_Outstanding')}
				help={t('PaymentHistory_Outstanding_Help')} />
			<Field name='refundedAmount' component={Input} disabled={isReadonly} horizontal label={t('PaymentHistory_Refund')}
				validate={[validators.number, min0]} help={t('PaymentHistory_Refund_Help')} />
		</Form>
	);
};

export default reduxForm({ form: 'markAsCancelled' })(withTranslation()(MarkAsCancelledForm));